import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-12 lg:py-24 relative overflow-hidden" data-id="element-191">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-brand-accent/5 blur-[150px] rounded-full pointer-events-none" data-id="element-192" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-193">
        <div className="text-center max-w-3xl mx-auto mb-10 lg:mb-20" data-id="element-194">
          <h2 className="text-brand-accent font-bold tracking-widest uppercase text-sm mb-4" data-id="element-195">
            Pricing Models
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-196">
            Revenue-Positive Scaling
          </h3>
          <p className="text-lg text-slate-400" data-id="element-197">
            We align our incentives with your growth. Choose the model that fits
            your current operational needs.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 items-center" data-id="element-198">
          {/* Side Card 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="p-8 rounded-3xl bg-white/5 border border-white/10" data-id="element-199">
            <h4 className="text-xl font-bold text-white mb-4" data-id="element-200">
              Retainer Services
            </h4>
            <p className="text-slate-400 text-sm mb-8" data-id="element-201">
              Best for ongoing operational support and dedicated staffing.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-202">
              {['Dedicated Staff', '24/7 Support', 'Admin Management', 'Full Integration'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sm text-slate-300" data-id="element-203">
                  <Check className="w-4 h-4 text-brand-accent" data-id="element-204" /> {item}
                </li>)}
            </ul>
            <button className="w-full py-3 rounded-xl border border-white/20 font-bold hover:bg-white/5 transition-all" data-id="element-205">
              Contact for Quote
            </button>
          </motion.div>

          {/* Main Featured Card */}
          <motion.div initial={{
          scale: 0.95,
          opacity: 0,
          y: 30
        }} whileInView={{
          scale: 1,
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="p-10 rounded-[2.5rem] bg-brand-accent text-brand-dark relative shadow-2xl shadow-brand-accent/20" data-id="element-206">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-white text-brand-dark px-6 py-1.5 rounded-full text-xs font-black uppercase tracking-widest shadow-xl" data-id="element-207">
              Most Popular
            </div>
            <h4 className="text-2xl font-black mb-2 uppercase tracking-tight" data-id="element-208">
              Pay As We Book
            </h4>
            <p className="text-brand-dark/70 font-medium mb-8" data-id="element-209">
              Performance-based lead generation.
            </p>

            <div className="mb-8" data-id="element-210">
              <span className="text-5xl font-black" data-id="element-211">$0</span>
              <span className="text-lg font-bold ml-2" data-id="element-212">Per Call / Setup</span>
            </div>

            <ul className="space-y-4 mb-10" data-id="element-213">
              {['Pay only per confirmed appointment', 'No cost per call or outreach', 'Revenue-positive model', 'HIPAA compliant handling', 'Performance guaranteed'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sm font-bold" data-id="element-214">
                  <Check className="w-5 h-5 text-brand-dark" data-id="element-215" /> {item}
                </li>)}
            </ul>

            <button className="w-full py-5 rounded-2xl bg-brand-dark text-white font-black text-lg hover:bg-slate-800 transition-all shadow-xl" data-id="element-216">
              Get Started Now
            </button>
            <div className="mt-6 flex items-center justify-center gap-2 text-xs font-bold opacity-60" data-id="element-217">
              <Shield className="w-4 h-4" data-id="element-218" /> SECURE & COMPLIANT
            </div>
          </motion.div>

          {/* Side Card 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="p-8 rounded-3xl bg-white/5 border border-white/10" data-id="element-219">
            <h4 className="text-xl font-bold text-white mb-4" data-id="element-220">
              Performance Lead Gen
            </h4>
            <p className="text-slate-400 text-sm mb-8" data-id="element-221">
              Aggressive outreach for high-volume growth targets.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-222">
              {['Custom Funnels', 'Lead Qualification', 'Email Prospecting', 'CRM Integration'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sm text-slate-300" data-id="element-223">
                  <Check className="w-4 h-4 text-brand-accent" data-id="element-224" /> {item}
                </li>)}
            </ul>
            <button className="w-full py-3 rounded-xl border border-white/20 font-bold hover:bg-white/5 transition-all" data-id="element-225">
              View Packages
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}